import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import {
  SectionViewedLogger,
  type SectionViewedLoggerProps
} from '@/vdp/Analytics';

export type EpicSectionProps = SectionViewedLoggerProps & {
  whiteBg?: boolean;
};

const generateEpicSectionClassName = (whiteBg?: boolean) =>
  cx(
    `relative
      [--yellow-line-offset:17px]
      -:pb-32
      -:pt-[calc(var(--yellow-line-offset)+32px)]
      -:m:pb-[50px]
      -:m:pt-[70px]`,
    whiteBg ? 'bg-white' : 'bg-grey-1'
  );

export const EpicSectionWithoutViewEvent = createComponent<EpicSectionProps>(
  'div',
  props => ({
    className: generateEpicSectionClassName(props.whiteBg)
  })
);

export const EpicSection = createComponent<EpicSectionProps>(
  SectionViewedLogger,
  props => ({
    className: generateEpicSectionClassName(props.whiteBg)
  })
);

export const SectionHeader = createComponent('h3', {
  className: `
    relative
    text-center
    text-[26px]/none
    font-bold
    uppercase
    text-blue-6
    before:absolute
    before:inset-x-0
    before:top-[calc(var(--yellow-line-offset)*-1)]
    before:mx-auto
    before:block
    before:h-[4px]
    before:w-[30px]
    before:bg-yellow-2
    before:content-[""]
    l:text-[42px]
  `
});

export const SectionSubHeader = createComponent('h4', {
  className: 'mt-xl w-full px-2xl text-center text-grey-5 tl-body-m'
});
